__turbopack_context__.v({
  "bookmarkIcon": "emptyLeg-module-scss-module__GDFyJW__bookmarkIcon",
  "bottomText": "emptyLeg-module-scss-module__GDFyJW__bottomText",
  "emptyLegCard": "emptyLeg-module-scss-module__GDFyJW__emptyLegCard",
  "emptyLegCardImg": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardImg",
  "emptyLegCardImgWrapper": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardImgWrapper",
  "emptyLegCardInfo": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfo",
  "emptyLegCardInfoButtonDesc": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoButtonDesc",
  "emptyLegCardInfoButtonMobile": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoButtonMobile",
  "emptyLegCardInfoCity": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoCity",
  "emptyLegCardInfoCityName": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoCityName",
  "emptyLegCardInfoPlain": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoPlain",
  "emptyLegCardInfoPlainName": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoPlainName",
  "emptyLegCardInfoPlainType": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoPlainType",
  "emptyLegCardInfoSeatsNumber": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoSeatsNumber",
  "emptyLegCardInfoSeatsNumberItem": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoSeatsNumberItem",
  "emptyLegCardInfoTime": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoTime",
  "emptyLegCardInfoTimeTo": "emptyLeg-module-scss-module__GDFyJW__emptyLegCardInfoTimeTo",
  "emptyLegSection": "emptyLeg-module-scss-module__GDFyJW__emptyLegSection",
  "emptyLegWrapper": "emptyLeg-module-scss-module__GDFyJW__emptyLegWrapper",
  "sectionTitle": "emptyLeg-module-scss-module__GDFyJW__sectionTitle",
  "upliftTitle": "emptyLeg-module-scss-module__GDFyJW__upliftTitle",
});
